export const tradeMenu = [
    {
      label: "Trading Portal",
      description: "Access the latest trading opportunities",
      path: "/trade/portal",
      icon: "📊"
    },
    {
      label: "Spot",
      description: "Trade the Spot market with up to 10x leverage",
      path: "/trade/spot",
      icon: "📈"
    },
    {
      label: "Futures",
      description: "Trade Perpetual and Futures contracts settled in USDT, etc.",
      path: "/trade/futures",
      icon: "📉"
    }
  ]
  